"use client";

import { useState, useEffect } from "react";

import {
  Smartphone,
  Shield,
  Zap,
  BarChart2,
  Globe,
  Server,
  Download,
  CheckCircle,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const features = [
  {
    icon: <Server size={24} />,
    title: "PSX FIX-Compliant OMS Gateway",
    description:
      "Direct connectivity to Pakistan Stock Exchange with industry-standard protocols",
  },
  {
    icon: <Zap size={24} />,
    title: "Instant Market Data",
    description:
      "Real-time market data and immediate order execution capabilities",
  },
  {
    icon: <BarChart2 size={24} />,
    title: "Pro-Trade Risk Management",
    description: "Online market-wide risk management system for secure trading",
  },
  {
    icon: <Globe size={24} />,
    title: "Universal Compatibility",
    description:
      "Compatible with any back-office software for seamless integration",
  },
  {
    icon: <Shield size={24} />,
    title: "Secure Access",
    description:
      "Advanced security protocols including OpenSSL, ASL, UUID encryption",
  },
  {
    icon: <Server size={24} />,
    title: "Comprehensive System",
    description: "Complete log management system for tracking and monitoring",
  },
];

const screenshots = [
  {
    url: "https://orbitsecurities.com.pk/wp-content/uploads/2025/02/T1.webp",
    alt: "Market Watch Screen",
    title: "Real-time Market Waaaatch",
  },
  {
    url: "https://orbitsecurities.com.pk/wp-content/uploads/2025/02/T2.webp",
    alt: "Order Screen",
    title: "Quick Order Entry",
  },
  {
    url: "https://orbitsecurities.com.pk/wp-content/uploads/2025/02/T5.webp",
    alt: "Portfolio Screen",
    title: "Portfolio Overview",
  },
];

export default function TradingPlatform() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % screenshots.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + screenshots.length) % screenshots.length
    );
  };

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".animate").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="platform-container">
      <main>
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-text animate">
              <h1>Your Convenient Gateway to PSX</h1>
              <p>
                With Vtrade Online Trading, you gain direct access to the
                Pakistan Stock Exchange, along with real-time tools, mobile
                trading platforms, and seamless account integration—making
                trading simpler than ever.
              </p>
              <div className="hero-buttons">
                <a href="/img/Vtrade-Setup.exe" className="cta-button">
                  <Download size={20} />
                  Download Now
                </a>
                <a href="/coming-soon" className="demo-button">
                  Try Demo
                </a>
              </div>
            </div>
            {/* <div className="hero-showcase animate">
              <div className="phone-mockup">
                {screenshots.map((screenshot, index) => (
                  <div
                    key={index}
                    className={`screenshot ${
                      index === currentSlide ? "active" : ""
                    }`}
                  >
                    <img
                      src={screenshot.url || "/placeholder.svg"}
                      alt={screenshot.alt}
                      width={280}
                      height={500}
                      className="screenshot-image"
                    />
                    <div className="screenshot-label">{screenshot.title}</div>
                  </div>
                ))}
                <button className="slider-button prev" onClick={prevSlide}>
                  <ChevronLeft size={24} />
                </button>
                <button className="slider-button next" onClick={nextSlide}>
                  <ChevronRight size={24} />
                </button>
              </div>
            </div> */}
          </div>
        </section>

        <section className="features-section padding-bootom-4">
          <div className="section-header animate">
            <h2>Advanced Trading Features</h2>
            <p>
              Experience professional-grade trading tools designed for modern
              investors
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card animate">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="specs-section">
          <div className="specs-content animate">
            <div className="specs-text">
              <h2>Technical Specifications</h2>
              <ul className="specs-list">
                <li>
                  <CheckCircle size={20} />
                  <span>
                    Unlimited Terminals for In-House, Branch and Client Access
                    (Internet-Based)
                  </span>
                </li>
                <li>
                  <CheckCircle size={20} />
                  <span>Real-time Market Data and Order Execution</span>
                </li>
                <li>
                  <CheckCircle size={20} />
                  <span>
                    Secure Login Protocols (OpenSSL, ASL, UUID,
                    Encryption/Decryption)
                  </span>
                </li>
                <li>
                  <CheckCircle size={20} />
                  <span>Comprehensive Log Management System</span>
                </li>
              </ul>
            </div>
            <div className="specs-image">
              <Smartphone className="phone-icon" />
              <div className="specs-decoration"></div>
            </div>
          </div>
        </section>

        <section className="cta-section animate">
          <div className="cta-content">
            <h2>Start Trading Today</h2>
            <p>
              Download our mobile trading platform and access the market
              anywhere, anytime
            </p>
            <div className="download-buttons">
              <a href="/coming-soon" className="store-button">
                <i className="fab fa-google-play"></i>
                <div>
                  <span>GET IT ON</span>
                  <strong>Google Play</strong>
                </div>
              </a>
              <a href="/coming-soon" className="store-button">
                <i className="fab fa-apple"></i>
                <div>
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
